import alignLeftIcon from '/agent/assets/icons/align-left.svg';
import alignCenterIcon from '/agent/assets/icons/align-center.svg';
import alignRightIcon from '/agent/assets/icons/align-right.svg';
import alignJustifyIcon from '/agent/assets/icons/align-justify.svg';
import backgroundIcon from '/agent/assets/icons/background.svg';
import blockquoteIcon from '/agent/assets/icons/blockquote.svg';
import boldIcon from '/agent/assets/icons/bold.svg';
import cleanIcon from '/agent/assets/icons/clean.svg';
import codeIcon from '/agent/assets/icons/code.svg';
import colorIcon from '/agent/assets/icons/color.svg';
import directionLeftToRightIcon from '/agent/assets/icons/direction-ltr.svg';
import directionRightToLeftIcon from '/agent/assets/icons/direction-rtl.svg';
import formulaIcon from '/agent/assets/icons/formula.svg';
import headerIcon from '/agent/assets/icons/header.svg';
import header2Icon from '/agent/assets/icons/header-2.svg';
import header3Icon from '/agent/assets/icons/header-3.svg';
import header4Icon from '/agent/assets/icons/header-4.svg';
import header5Icon from '/agent/assets/icons/header-5.svg';
import header6Icon from '/agent/assets/icons/header-6.svg';
import italicIcon from '/agent/assets/icons/italic.svg';
import imageIcon from '/agent/assets/icons/image.svg';
import indentIcon from '/agent/assets/icons/indent.svg';
import outdentIcon from '/agent/assets/icons/outdent.svg';
import linkIcon from '/agent/assets/icons/link.svg';
import listBulletIcon from '/agent/assets/icons/list-bullet.svg';
import listCheckIcon from '/agent/assets/icons/list-check.svg';
import listOrderedIcon from '/agent/assets/icons/list-ordered.svg';
import subscriptIcon from '/agent/assets/icons/subscript.svg';
import superscriptIcon from '/agent/assets/icons/superscript.svg';
import strikeIcon from '/agent/assets/icons/strike.svg';
import tableIcon from '/agent/assets/icons/table.svg';
import underlineIcon from '/agent/assets/icons/underline.svg';
import videoIcon from '/agent/assets/icons/video.svg';

export default {
  align: {
    '': alignLeftIcon,
    center: alignCenterIcon,
    right: alignRightIcon,
    justify: alignJustifyIcon,
  },
  background: backgroundIcon,
  blockquote: blockquoteIcon,
  bold: boldIcon,
  clean: cleanIcon,
  code: codeIcon,
  'code-block': codeIcon,
  color: colorIcon,
  direction: {
    '': directionLeftToRightIcon,
    rtl: directionRightToLeftIcon,
  },
  formula: formulaIcon,
  header: {
    '1': headerIcon,
    '2': header2Icon,
    '3': header3Icon,
    '4': header4Icon,
    '5': header5Icon,
    '6': header6Icon,
  },
  italic: italicIcon,
  image: imageIcon,
  indent: {
    '+1': indentIcon,
    '-1': outdentIcon,
  },
  link: linkIcon,
  list: {
    bullet: listBulletIcon,
    check: listCheckIcon,
    ordered: listOrderedIcon,
  },
  script: {
    sub: subscriptIcon,
    super: superscriptIcon,
  },
  strike: strikeIcon,
  table: tableIcon,
  underline: underlineIcon,
  video: videoIcon,
};
